import View from "./View";

export * from "./AArrowDown";
export * from "./AArrowUp";
export * from "./ALargeSmall";
export * from "./AppWindow";
export * from "./AppWindowMac";
export * from "./Axis3d";
export * from "./BetweenVerticalEnd";
export * from "./BetweenVerticalStart";
export * from "./Blend";
export * from "./BookType";
export * from "./BoxSelect";
export * from "./BringToFront";
export * from "./Brush";
export * from "./Columns2";
export * from "./Columns3";
export * from "./Columns4";
export * from "./Component";
export * from "./Crop";
export * from "./Cylinder";
export * from "./Diameter";
export * from "./Dock";
export * from "./DraftingCompass";
export * from "./FileAxis3d";
export * from "./FlipHorizontal";
export * from "./FlipHorizontal2";
export * from "./FlipVertical";
export * from "./FlipVertical2";
export * from "./Frame";
export * from "./Fullscreen";
export * from "./GalleryHorizontal";
export * from "./GalleryHorizontalEnd";
export * from "./GalleryThumbnails";
export * from "./GalleryVertical";
export * from "./GalleryVerticalEnd";
export * from "./Grid2X2";
export * from "./Grid2X2Check";
export * from "./Grid2X2X";
export * from "./Grid3X3";
export * from "./Highlighter";
export * from "./IterationCc";
export * from "./LandPlot";
export * from "./Lasso";
export * from "./Layers";
export * from "./Layers2";
export * from "./Layers3";
export * from "./LayoutDashboard";
export * from "./LayoutGrid";
export * from "./LayoutPanelLeft";
export * from "./Magnet";
export * from "./Maximize";
export * from "./Minimize";
export * from "./Move3D";
export * from "./Nootbook";
export * from "./Paintbrush";
export * from "./PaintRoller";
export * from "./Palette";
export * from "./PanelTop";
export * from "./Paperclip";
export * from "./Pen";
export * from "./PencilLine";
export * from "./Pipette";
export * from "./Proportions";
export * from "./Radius";
export * from "./Ratio";
export * from "./RectangleHorizontal";
export * from "./RectangleVertical";
export * from "./Rotate3D";
export * from "./Rows2";
export * from "./Rows3";
export * from "./Rows4";
export * from "./Ruler";
export * from "./Scale3D";
export * from "./Scaling";
export * from "./Scissors";
export * from "./ScissorsLineDashed";
export * from "./SendToBack";
export * from "./Slice";
export * from "./Spline";
export * from "./SprayCan";
export * from "./SquareBottomDashedScissors";
export * from "./SquareScissors";
export * from "./SwatchBook";
export * from "./TableSmartphone";
export * from "./Torus";
export * from "./View";

export const Designss = {
  View,
};
